import { Bot, Calendar, Target, Clock } from "lucide-react";

const features = [
	{
		icon: Bot,
		title: "Automatización Inteligente de Consultas",
		description:
			"Nuestro agente de IA resuelve consultas complejas al instante, permitiendo que tu equipo se enfoque en tareas estratégicas de alto valor.",
	},
	{
		icon: Calendar,
		title: "Coordinación de Agendas y Citas",
		description:
			"Automatiza la programación de citas y reuniones, optimizando el tiempo de tu equipo y mejorando la experiencia del cliente.",
	},
	{
		icon: Target,
		title: "Generación y Cualificación de Leads",
		description:
			"Identifica y cualifica clientes potenciales con conversaciones naturales, nutriendo cada oportunidad de venta de forma efectiva.",
	},
	{
		icon: Clock,
		title: "Soporte Ininterrumpido 24/7",
		description:
			"Ofrece soporte ininterrumpido. Nuestros agentes están disponibles 24/7, incluyendo fines de semana y festivos, garantizando respuestas rápidas.",
	},
];

const Features = () => {
	return (
		<section className="py-16 px-4 sm:px-6 bg-secondary/50">
			<div className="container mx-auto max-w-7xl">
				<div className="text-center mb-16">
					<h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
						Potencia tu{" "}
						<span className="text-primary">Negocio</span>
					</h2>
					<p className="text-lg sm:text-xl text-muted-foreground max-w-3xl mx-auto">
						Características diseñadas para impulsar tu crecimiento
					</p>
				</div>

				<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
					{features.map((feature, index) => {
						const Icon = feature.icon;

						return (
							<div
								key={index}
								className="group bg-card border border-border rounded-xl p-6 sm:p-8 hover:border-primary/50 transition-all duration-300 hover:shadow-xl"
							>
								<div className="flex flex-col sm:flex-row items-start gap-6">
									<div className="flex-shrink-0 w-12 h-12 sm:w-14 sm:h-14 rounded-lg bg-primary/10 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
										<Icon className="h-6 w-6 sm:h-7 sm:w-7 text-primary" />
									</div>

									<div className="space-y-3 text-left">
										<h3 className="text-lg sm:text-xl font-bold text-foreground">
											{feature.title}
										</h3>
										<p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
											{feature.description}
										</p>
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</section>
	);
};

export default Features;
